import { render } from "./DessinView.vue?vue&type=template&id=10551332"
import script from "./DessinView.vue?vue&type=script&lang=js"
export * from "./DessinView.vue?vue&type=script&lang=js"

import "./DessinView.vue?vue&type=style&index=0&id=10551332&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__